// Locale-aware SEO content store.
// Mirrors the translations.ts async-load pattern. Falls back to English on missing locale or load failure.
import { locale } from '@infinitro/global';
import { writable } from 'svelte/store';
import en from './seo/en.json';
export const seoContent = writable(en);
// Flips true after the first loadSeoContent call settles — gates meta tag updates to avoid English flash
export const seoContentReady = writable(false);
const KR_FOMO_BRAND = 'kr.fomo.io';
// Only locales with translated SEO content; all others fall back to English
const asyncSeoContent = {
    ko: () => import.meta.env.VITE_BRAND === KR_FOMO_BRAND
        ? import('./seo/ko.fomo.json')
        : import('./seo/ko.json'),
    cs: () => import('./seo/cs.json'),
    de: () => import('./seo/de.json'),
    es: () => import('./seo/es.json'),
    fr: () => import('./seo/fr.json'),
    it: () => import('./seo/it.json'),
    ja: () => import('./seo/ja.json'),
    pt: () => import('./seo/pt.json'),
    ru: () => import('./seo/ru.json'),
    zh: () => import('./seo/zh.json')
};
export async function loadSeoContent(lang) {
    if (lang === 'en' || !asyncSeoContent[lang]) {
        seoContent.set(en);
        seoContentReady.set(true);
        return;
    }
    try {
        const module = await asyncSeoContent[lang]();
        // Deep merge: locale entries override English; untranslated entries fall back to English
        const base = en;
        const merged = {
            routes: { ...base.routes, ...module.default.routes },
            patterns: { ...base.patterns, ...module.default.patterns }
        };
        seoContent.set(merged);
    }
    catch {
        seoContent.set(en);
    }
    seoContentReady.set(true);
}
// Auto-reload when locale changes
locale.subscribe((lang) => loadSeoContent(lang));
